export const PERFORMANCE_ICON=`<svg x="0" y="0" viewBox="0 0 43.349 43.349" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path fill-rule="nonzero" d="M21.675 6C11.34 6 2.965 14.377 2.965 24.71c0 5.254 2.05 9.82 5.75 13.507l-2.084 2.096C2.375 36.072 0 30.751 0 24.711 0 12.74 9.705 3.036 21.675 3.036s21.674 9.705 21.674 21.675c0 6.04-2.374 11.36-6.631 15.602l-2.084-2.096c3.7-3.687 5.75-8.253 5.75-13.506C40.385 14.377 32.009 6 21.675 6z" fill="#032836" data-original="#000000" class=""></path><path d="M21.177 22.205a2.369 2.369 0 1 1-1.818 1.818l-6.048-7.865zM22.985 4.856V9.69h-2.621V4.856zM41.53 25.831h-5.175v-2.621h5.175zm-4.962-14.347-3.438 3.438-1.854-1.854 3.438-3.438zM1.82 25.832v-2.621h5.175v2.621zm4.963-14.347L8.636 9.63l3.438 3.438-1.854 1.854zm29.45 26.585-3.2-3.2 1.853-1.854 3.2 3.2zm-29.117 0-1.854-1.854 3.2-3.2 1.855 1.853z" ></path></g></svg>`
export const PERFORMANCE_FRAME_RATE={
    low:5,
    balanced:18,
    high:30
};

export const VBG_PERFORMANCE_FRAME_RATE={
    low:2,
    balanced:6,
    high:10
};

export const FRAMERATE_DROP_THRESHOLD_PERCENT={
    balanced:30,
    high:30
};

export const VB_FRAMERATE_DROP_THRESHOLD_PERCENT={
    balanced:40,
    high:66
};

export const FRAMERATE_RECOVERY_THRESHOLD_PERCENT=0;
export const FRAMERATE_RECOVERY_CHECKS=3;
// Number of down->up oscillations tolerated before we stop auto-recovering the
// performance setting. A value of 1 permanently pinned senders at a degraded
// tier after a single transient CPU spike, which kept the bridge's bandwidth
// estimate low for every receiver of that source. Allow more oscillations and
// pair this with a stable-period reset in LoadMonitor so recovery resumes once
// the CPU clears.
export const STOP_RECOVER_THRESHOLD = 5;
// How many consecutive stable (non-drop) checks reset the oscillation counter,
// so a brief CPU spike earlier in the session does not permanently disable
// recovery back to full quality.
export const RECOVER_COUNT_RESET_CHECKS = 5;
